import React from 'react';
import styled from 'styled-components';
import { ErrorMessage } from '~/component/common/ErrorMessage';

const FormGroupContainer = styled.div`
  margin: 8px 0 16px;
  padding: 16px 0;
  background-color: #f5f5f5;
`

const FormGroupTitle = styled.h2`
  font-size: 14px;
  margin: 0 0 16px;
  text-align: center;
  font-weight: bold;
  color: #333;
`

export type ErrorMessageType = string | undefined
export const FormGroup: React.FC<{ title: string, warningMessage?: string}> = (props) => {
  return <FormGroupContainer>
    <FormGroupTitle>{props.title} {props.warningMessage && <ErrorMessage message={props.warningMessage} />}</FormGroupTitle>
    {props.children}
  </FormGroupContainer>
}

export default FormGroup
